import type { VoidFunctionComponent } from 'react';
import DrawerSection from './Section';
import DrawerLoading from './Loading';
import DetailsPanel from '../../../generic/DetailsPanel';
import Markdown from '../../../generic/Markdown';

type Props = {
  isLoading?: boolean;
  description: string;
};

/**
 * VulnerabilityDrawerDescription simply displays the
 * description of the vuln, or a loading UI if it's loading.
 */
export const VulnerabilityDrawerDescription: VoidFunctionComponent<Props> = ({ isLoading, description }) => (
  <DrawerSection>
    {isLoading ? (
      <DrawerLoading.Description />
    ) : (
      <DetailsPanel
        id="package-inventory-vuln-drawer-description"
        target="Description of vulnerability"
        isLoading={isLoading}
      >
        {description ? (
          <Markdown text={description} />
        ) : (
          <span className="italic">No description found</span>
        )}
      </DetailsPanel>
    )}
  </DrawerSection>
);

export default VulnerabilityDrawerDescription;
